import React from 'react';
import s from '../../PromoBadge.scss';
const TierUnlocked16 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7 .577a2 2 0 0 1 2 0l4.928 2.846a2 2 0 0 1 1 1.732v5.69a2 2 0 0 1-1 1.732L9 15.423a2 2 0 0 1-2 0l-4.928-2.846a2 2 0 0 1-1-1.732v-5.69a2 2 0 0 1 1-1.732L7 .577Z",
        className: s['fill-color']
    }));
TierUnlocked16.displayName = 'TierUnlocked16';
export default TierUnlocked16;
